<template>
  <template v-if="showToolbar">
    <m-a class="edit-item-1" :href="routerParams">
      <m-icon icon="pencil" class="btn btn-primary"/>
    </m-a>
  </template>
</template>

<script>
/*
* this component can be use on product, any content(post, page and lesson) and course to
* redirect user to edit mode of that item in dashboard.
*
* */
import {mapGetters} from "vuex";
import {findRoutes} from '@moeinmdn/miw-router/src/package/RouterFunctions'
import {siteRoutes} from '@moeinmdn/miw-router/src/package/routes/SiteRoutes'
import {dashboardRoutesTemplateChild} from '@moeinmdn/miw-router/src/package/routes/SiteRoutes'

import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon'

export default {
  name: "Edit1",
  components: {mA, mIcon},
  data() {
    return {
      supportedRoutes: {
        'Product': 'EditProduct',
        'SinglePost': 'UpdateContent',
        'SinglePage': 'UpdateContent',
        'SingleLesson': 'UpdateLessons',
        'SingleCourse': 'EditCourse',
        'ProductShare': 'EditProduct'
      }
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: 'User/isAdmin'
    }),
    routerParams() {
      let routes = []

      // combine dashboard and site routes
      dashboardRoutesTemplateChild.forEach(item => {
        routes.push(item)
      })
      siteRoutes.forEach(item => {
        routes.push(item)
      })

      const dashboardRoute = this.findRoutes(routes, [this.selectedType])[0];

      let link = '';
      if (this.$route.name == 'Product') {
        link = dashboardRoute.path.replace(':slug', this.$route.params.name)
      } else {
        link = dashboardRoute.path.replace(':slug', this.$route.params.slug)
      }


      return this.findAttributeOnSiteInfo('dashboard_link')[0] + link


    },
    selectedType() {
      return this.supportedRoutes[this.$route.name]
    },
    showToolbar() {
      return this.isAdmin && this.selectedType != undefined
    }
  },
  methods: {
    findRoutes,
  },
  mounted() {
  }
}
</script>

<style scoped>
.edit-item-1 {
  top: auto;
  right: auto;
  left: 30px;
  bottom: 90px;
  z-index: 100;
  position: fixed;
  height: 40px;
  font-size: 35px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}

.edit-item-1 .btn {
  border-radius: 50%;
}

</style>
